import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";

import styled from "styled-components";

import { Card, Button, TextField, Heading, Badge, Icon } from "@aidron/aidron-ds";
import { i18n } from "../../translate/i18n";
import { doLogin } from "../../model/services/AuthService";

import { LanguageSelector } from "../../components/SharedComponents/sharedComponents.index";

const EyeButton = styled.button`
  position: absolute;
  right: 24px;
  top: 32px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  color: #737373;

  &:hover {
    color: #404040;
  }
`;

export function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [disableLogin, setDisableLogin] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const onSubmit = useCallback((event) => {
    event.preventDefault();

    doLogin(email, password)
      .then(response => {
        localStorage.setItem("token", response.token);
        localStorage.setItem("exp", response.exp);

        navigate("/home");
      })
      .catch(err => {
        console.error(err);
        setError(`${i18n.t("login.error")}`);
      });
}, [email, password, navigate]);


  const enterClick = useCallback(
    e => {
      if (e.keyCode === 13 && !disableLogin) {
        onSubmit(e);
      }
    },
    [disableLogin, onSubmit]
  );

  useEffect(() => {
    document.addEventListener("keydown", enterClick);
    return () => {
      document.removeEventListener("keydown", enterClick);
    };
  }, [enterClick]);

  useEffect(() => {
    setDisableLogin(!email || !password);
  }, [email, password]);

  return (
    <section>
      <div style={{ display: 'flex', justifyContent: 'end', padding: '1rem 5rem 0 0' }}>
        <LanguageSelector ctx={{ iconColor: "#737373" }} />
      </div>

      <div className="container">
        <div className="col-12 d-flex align-items-center justify-content-center">
          <div className="w-100 fmxw-500">
            <Card style={{ padding: "30px" }}>

              <div className="d-flex justify-content-center">
                <img className="mb-3" src="/img/favicon/ms-icon-150x150.png" alt="Aidron" width={150} />
              </div>

              <div className="text-center text-md-center mb-5 mt-md-2">
                <Heading size="md">{i18n.t("login.title")}</Heading>
              </div>

              <div className="d-flex flex-column no-wrap mb-2">
                <TextField
                  width="500"
                  iconLeft="mail"
                  label={i18n.t("login.emailLabel")}
                  type="email"
                  placeholder={i18n.t("login.emailPlaceholder")}
                  onChange={value => setEmail(value)}
                  autoFocus
                  required
                  size="lg"
                />

                <div style={{ position: 'relative' }}>
                  <TextField
                    width="500"
                    iconLeft="lock"
                    label={i18n.t("login.passwordLabel")}
                    type={showPassword ? "text" : "password"}
                    placeholder={i18n.t("login.passwordPlaceholder")}
                    onChange={value => setPassword(value)}
                    required
                    size="lg"
                  />
                  <EyeButton
                    type="button"
                    onClick={() => setShowPassword(prev => !prev)}
                    aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
                  >
                    <Icon icon={showPassword ? "eye-off" : "eye"} size={18} />
                  </EyeButton>
                </div>

                {/* <div className="d-flex justify-content-center mb-3">
                  <ReCAPTCHA sitekey={RECAPTCHA_SITEKEY} onChange={handleCaptcha} />
                </div> */}

              </div>
              
              <div className="d-flex justify-content-center">
                <Button
                  className="d-flex justify-content-center w-50 loginButton"
                  label={i18n.t("login.signIn")}
                  size="lg"
                  onClick={onSubmit}
                  disabled={disableLogin}
                />
              </div>
              
              {error ? (
                <Badge style={{ marginTop: "15px", padding: "12px" }} variant="danger">
                  {error}
                </Badge>
              ) : (
                <></>
              )}
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};